/* ============================================================
   BAOBA – Mon Pack : « pack en cours » partage sur tout le site
   - memorise les produits ajoutes avec « Ajouter a mon pack » (localStorage)
   - la page Mon Pack relit ce pack pour le finaliser (« Creer mon pack »)
   - les petits formats (moins de 5,95 EUR) ne s'achetent pas seuls : tout envoi
     d'un formulaire d'ajout au panier pour ces variantes est converti en
     ajout au pack
   Le seuil de prix et les paliers sont definis dans snippets/mon-pack-rules.liquid
   ============================================================ */
(function () {
  if (window.BaobaPack) return;

  var STORAGE_KEY = 'baoba_mon_pack_v1';
  var TTL = 14 * 24 * 60 * 60 * 1000;

  var config = {
    min: 595,
    max: 5,
    url: '/pages/mon-pack',
    tiers: [{ qty: 3, pct: 10 }, { qty: 4, pct: 15 }, { qty: 5, pct: 20 }],
  };
  var registry = {}; // id de variante -> { pid, packOnly, available, price }
  var memory = null; // pack garde en memoire si localStorage est indisponible
  var persistent = canPersist();
  var toast = null;
  var toastTimer = null;

  function canPersist() {
    try {
      var key = STORAGE_KEY + '_test';
      window.localStorage.setItem(key, '1');
      window.localStorage.removeItem(key);
      return true;
    } catch (e) {
      return false;
    }
  }

  function esc(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML.replace(/"/g, '&quot;');
  }

  /* ---------- Pack en cours (stockage) ---------- */

  function cleanItem(raw) {
    if (!raw) return null;
    var id = String(raw.id || '').replace(/\D/g, '');
    var qty = parseInt(raw.qty, 10);
    if (!id || !(qty > 0)) return null;
    return { id: id, qty: qty, pid: String(raw.pid || '').replace(/\D/g, '') };
  }

  function readItems() {
    if (!persistent) return (memory || []).slice();
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var data = JSON.parse(raw);
      if (!data || !Array.isArray(data.items) || (data.ts && Date.now() - data.ts > TTL)) {
        window.localStorage.removeItem(STORAGE_KEY);
        return [];
      }
      return data.items.map(cleanItem).filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  function writeItems(items) {
    items = (items || []).map(cleanItem).filter(Boolean);
    if (!persistent) {
      memory = items;
    } else {
      try {
        if (items.length) {
          window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ ts: Date.now(), items: items }));
        } else {
          window.localStorage.removeItem(STORAGE_KEY);
        }
      } catch (e) {
        persistent = false;
        memory = items;
      }
    }
    updateStatus();
    try {
      window.dispatchEvent(new CustomEvent('baoba:pack-change', { detail: { items: items } }));
    } catch (e) {}
  }

  function totalQty(items) {
    return items.reduce(function (sum, item) {
      return sum + item.qty;
    }, 0);
  }

  /* Ajoute une variante au pack (une seule variante par produit, jamais plus de config.max produits) */
  function addItem(variantId, qty, productId) {
    variantId = String(variantId).replace(/\D/g, '');
    productId = String(productId || '').replace(/\D/g, '');
    qty = Math.max(1, parseInt(qty, 10) || 1);

    var items = readItems();
    var total = totalQty(items);
    var same = null;
    var sameProduct = null;
    items.forEach(function (item) {
      if (item.id === variantId) same = item;
      else if (productId && item.pid === productId) sameProduct = item;
    });

    // Autre format d'un produit deja dans le pack : on change le format, la quantite reste la meme
    if (!same && sameProduct) {
      sameProduct.id = variantId;
      writeItems(items);
      return { status: 'replaced', items: items, total: total, added: 0 };
    }

    var room = config.max - total;
    if (room <= 0) return { status: 'full', items: items, total: total, added: 0 };

    var added = Math.min(qty, room);
    if (same) same.qty += added;
    else items.push({ id: variantId, qty: added, pid: productId });

    writeItems(items);
    return {
      status: added < qty ? 'partial' : 'added',
      items: items,
      total: total + added,
      added: added,
    };
  }

  /* Phrase de progression, identique a celle de la page Mon Pack */
  function progressMessage(total) {
    var tiers = config.tiers;
    var first = tiers[0];
    var active = null;
    var next = null;
    tiers.forEach(function (tier) {
      if (total >= tier.qty) active = tier;
      else if (!next) next = tier;
    });
    var plural = function (n) {
      return n + ' produit' + (n > 1 ? 's' : '');
    };
    if (!active) return 'Encore ' + plural(first.qty - total) + ' pour débloquer -' + first.pct + '%';
    if (next) return '-' + active.pct + '% débloqué, encore ' + plural(next.qty - total) + ' pour -' + next.pct + '%';
    return 'Remise maximale -' + active.pct + '% débloquée';
  }

  /* ---------- Donnees des variantes (prix, petit format) ---------- */

  function scanRegistry() {
    var scripts = document.querySelectorAll('script[data-mon-pack-variants]:not([data-mon-pack-read])');
    Array.prototype.forEach.call(scripts, function (script) {
      script.setAttribute('data-mon-pack-read', '1');
      try {
        var data = JSON.parse(script.textContent);
        (data.variants || []).forEach(function (variant) {
          registry[String(variant.id)] = {
            pid: String(data.productId || ''),
            packOnly: !!variant.packOnly,
            available: variant.available !== false,
            price: variant.price,
          };
        });
      } catch (e) {}
    });
  }

  function readConfig() {
    var cta = document.querySelector('[data-mon-pack-cta][data-config]');
    if (!cta || cta.getAttribute('data-config-read')) return;
    cta.setAttribute('data-config-read', '1');
    try {
      var data = JSON.parse(cta.getAttribute('data-config'));
      if (data.min) config.min = data.min;
      if (data.max) config.max = data.max;
      if (data.url) config.url = data.url;
      if (data.tiers && data.tiers.length) config.tiers = data.tiers;
    } catch (e) {}
  }

  /* ---------- Etat des boutons (variante choisie) ---------- */

  function variantIdIn(element) {
    var form = element && element.closest ? element.closest('form') : null;
    if (!form || !form.elements) return null;
    var field = form.elements['id'];
    return field && field.value ? String(field.value) : null;
  }

  function setAvailability(button, available) {
    var title = button.querySelector('.mon-pack-cta__title');
    if (title) {
      if (!button.getAttribute('data-title-ok')) button.setAttribute('data-title-ok', title.textContent);
      title.textContent = available ? button.getAttribute('data-title-ok') : 'Épuisé';
    }
    button.disabled = !available;
  }

  function refreshButtons() {
    var groups = document.querySelectorAll('[data-mon-pack-buttons]');
    Array.prototype.forEach.call(groups, function (group) {
      var id = variantIdIn(group);
      var entry = id ? registry[id] : null;
      if (!entry) return;
      group.setAttribute('data-pack-only', String(entry.packOnly));
      var form = group.closest('form');
      if (form) form.setAttribute('data-pack-only', String(entry.packOnly));
      var button = group.querySelector('[data-mon-pack-cta] [data-pack-add]');
      if (button) setAvailability(button, entry.available);
    });
    refreshSticky();
  }

  function refreshSticky() {
    var sticky = document.getElementById('md-sticky-atc');
    if (!sticky) return;
    var select = sticky.querySelector('select[name="id"]');
    var entry = select && select.value ? registry[String(select.value)] : null;
    if (entry) sticky.setAttribute('data-pack-only', String(entry.packOnly));
  }

  function updateStatus() {
    var items = readItems();
    var total = totalQty(items);
    var nodes = document.querySelectorAll('[data-mon-pack-status]');
    Array.prototype.forEach.call(nodes, function (node) {
      if (!total) {
        node.hidden = true;
        node.innerHTML = '';
        return;
      }
      node.innerHTML =
        '<span>Mon pack : <strong>' + total + '/' + config.max + '</strong> produit' + (total > 1 ? 's' : '') +
        '. ' + esc(progressMessage(total)) + '.</span> <a href="' + esc(config.url) + '">Voir mon pack</a>';
      node.hidden = false;
    });
  }

  // Au chargement, l'etat rendu par Liquid (variante affichee) fait foi : on ne touche qu'au
  // contenu dynamique. Les boutons suivent ensuite chaque changement de format.
  function initState() {
    readConfig();
    scanRegistry();
    updateStatus();
  }

  function refreshState() {
    readConfig();
    scanRegistry();
    refreshButtons();
    updateStatus();
  }

  /* ---------- Retour visuel ---------- */

  function showToast(title, text) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'mon-pack-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML =
      '<span class="mon-pack-toast__text"><strong>' + esc(title) + '</strong>' +
      (text ? '<span>' + esc(text) + '</span>' : '') +
      '</span><a class="mon-pack-toast__link" href="' + esc(config.url) + '">Voir mon pack</a>';
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 5500);
  }

  function flashButton(button, total) {
    var title = button && button.querySelector ? button.querySelector('.mon-pack-cta__title') : null;
    if (!title) return;
    if (!button.getAttribute('data-title-ok')) button.setAttribute('data-title-ok', title.textContent);
    title.textContent = '✓ Ajouté (' + total + '/' + config.max + ')';
    button.classList.add('is-added');
    clearTimeout(button._monPackTimer);
    button._monPackTimer = setTimeout(function () {
      title.textContent = button.getAttribute('data-title-ok');
      button.classList.remove('is-added');
    }, 2200);
  }

  function goToBuilder(items) {
    var param = items
      .map(function (item) {
        return item.id + ':' + item.qty;
      })
      .join(',');
    window.location.href = config.url + (param ? '?pack=' + encodeURIComponent(param) : '');
  }

  function addToPack(variantId, qty, productId, button) {
    var result = addItem(variantId, qty, productId);
    // Navigateur sans stockage : on transmet le pack a la page Mon Pack dans l'URL
    if (!persistent) {
      goToBuilder(result.items);
      return result;
    }
    if (result.status === 'full') {
      showToast('Votre pack est complet (' + result.total + '/' + config.max + ')', 'Finalisez-le pour commander.');
      return result;
    }
    var title = 'Ajouté à votre pack (' + result.total + '/' + config.max + ')';
    if (result.status === 'replaced') title = 'Format mis à jour (ce produit est déjà dans votre pack)';
    if (result.status === 'partial') title += ', limité à ' + config.max + ' produits';
    showToast(title, progressMessage(result.total));
    flashButton(button, result.total);
    return result;
  }

  /* ---------- Ecouteurs ---------- */

  // Boutons « Ajouter a mon pack »
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-pack-add]') : null;
    if (!button) return;
    event.preventDefault();
    if (button.disabled) return;
    scanRegistry();

    var variantId = button.getAttribute('data-pack-add');
    var productId = button.getAttribute('data-pack-pid') || '';
    var qty = 1;

    if (!variantId) {
      // Bouton de la page produit : variante et quantite choisies sur la page
      var group = button.closest('[data-mon-pack-buttons]');
      variantId = group ? variantIdIn(group) : null;
      var info = button.closest('product-info');
      var qtyInput = info ? info.querySelector('.quantity__input') : null;
      qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var cta = button.closest('[data-mon-pack-cta]');
      if (cta) productId = cta.getAttribute('data-product-id') || productId;
    }
    if (!variantId) return;
    if (!productId && registry[variantId]) productId = registry[variantId].pid;
    addToPack(variantId, qty, productId, button);
  });

  // Garde-fou : un petit format ne part JAMAIS au panier seul, quel que soit le formulaire
  // (page produit, barre collante, fenetre d'ajout rapide...). On le range dans le pack.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
      scanRegistry();
      var field = form.elements && form.elements['id'];
      var variantId = field && field.value ? String(field.value) : '';
      if (!variantId) return;
      var entry = registry[variantId];
      var packOnly = entry ? entry.packOnly : form.getAttribute('data-pack-only') === 'true';
      if (!packOnly) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      var qtyField = form.elements['quantity'];
      var qty = qtyField && qtyField.value ? parseInt(qtyField.value, 10) || 1 : 1;
      addToPack(variantId, qty, entry ? entry.pid : '', null);
    },
    true
  );

  // Changement de variante sur la page produit
  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (target && target.matches && target.matches('input[name="id"], select[name="id"]')) {
        setTimeout(refreshState, 0);
      }
    },
    true
  );
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      setTimeout(refreshState, 0);
    });
  }
  window.addEventListener('pageshow', initState);
  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) updateStatus();
  });
  document.addEventListener('shopify:section:load', initState);

  // La barre collante choisit sa variante par script (sans evenement) : on la surveille
  var stickySelect = document.querySelector('#md-sticky-atc select[name="id"]');
  var lastStickyId = stickySelect ? stickySelect.value : null;
  setInterval(function () {
    if (document.hidden) return;
    var sticky = document.getElementById('md-sticky-atc');
    var select = sticky ? sticky.querySelector('select[name="id"]') : null;
    var id = select ? select.value : null;
    if (id !== lastStickyId) {
      lastStickyId = id;
      refreshSticky();
    }
  }, 600);

  window.BaobaPack = {
    config: config,
    store: {
      read: readItems,
      write: writeItems,
      clear: function () {
        writeItems([]);
      },
      add: addItem,
      total: function () {
        return totalQty(readItems());
      },
      persistent: function () {
        return persistent;
      },
    },
    isPackOnly: function (variantId) {
      scanRegistry();
      var entry = registry[String(variantId)];
      return !!(entry && entry.packOnly);
    },
    addToPack: addToPack,
    progressMessage: progressMessage,
    refresh: refreshState,
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initState);
  else initState();
})();
